import React from "react";
import { observer } from "mobx-react-lite";

import useStores from "@hooks/useStores";
import useStyles from "@hooks/useStyles";

import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";

import ArrowUp from "@material-ui/icons/ArrowUpwardOutlined";
import ArrowDown from "@material-ui/icons/ArrowDownwardOutlined";

const ReviewsNav = observer(() => {
	const { clientReviewsStore: store } = useStores();
	const classes = useStyles("ClientReviews");

	const handleSort = () => {
		store.changeSort();
	};

	return (
		<Box
			display={"flex"}
			alignItems={"center"}
			justifyContent={"flex-end"}
			mb={3}
		>
			<Button
				className={classes.sortButton}
				size={"large"}
				endIcon={store.currentSort === 0 ? <ArrowUp /> : <ArrowDown />}
				onClick={handleSort}
			>
				Sort by date
			</Button>
		</Box>
	);
});

export default ReviewsNav;
